import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/moov-common/base/base.component';

@Component({
  selector: 'app-done-discovery-process',
  templateUrl: './done-discovery-process.component.html',
  styleUrls: ['./done-discovery-process.component.scss']
})
export class DoneDiscoveryProcessComponent
  extends BaseComponent
  implements OnInit {

  messageKeyPrefix: string = 'discoveryProcess.discoveryDoneMessage';

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: { messageKeyPrefix?: string } | null) {
    super();
    if (data?.messageKeyPrefix) {
      this.messageKeyPrefix = data.messageKeyPrefix;
    }
  }

  ngOnInit(): void {
  }

  

}
